var HIDDEN_TEXT_PLUS_ICON =
  "https://cdn.shopify.com/s/files/1/0603/9594/6243/files/ic-plus-circle.png?v=1751644003";
var HIDDEN_TEXT_MINUS_ICON =
  "https://cdn.shopify.com/s/files/1/0603/9594/6243/files/ic-minus-circle.png?v=1751644003";

enableHiddenText();

function enableHiddenText() {
  var buttons = document.getElementsByClassName("btn-read-more");
  for (var i = 0; i < buttons.length; i++) {
    var button = buttons[i];
    if (button.getAttribute("data-hidden-text-bound") === "true") continue;
    button.setAttribute("data-hidden-text-bound", "true");
    button.addEventListener("click", function (event) {
      event.preventDefault();
      onButtonClick(button);
    });
  }
}

function onButtonClick(button) {
  var section = button.closest(".new-hidden-text-section");
  var element = section
    ? section.querySelector(".new-hidden-text-text-container")
    : document.querySelector(".new-hidden-text-text-container");

  if (!element) return;

  var icon = button.querySelector("img");
  var isClosing = element.classList.contains("active");

  if (isClosing) {
    element.classList.remove("active");
    button.classList.remove("active");
    button.setAttribute("aria-expanded", "false");
    if (icon) icon.src = HIDDEN_TEXT_PLUS_ICON;
  } else {
    element.classList.add("active");
    button.classList.add("active");
    button.setAttribute("aria-expanded", "true");
    if (icon) icon.src = HIDDEN_TEXT_MINUS_ICON;
  }
}

// Gentle pulse on collapsed toggles (matches pilot section rhythm).
(function () {
  var buttons = document.querySelectorAll(".btn-read-more");
  if (!buttons.length || window.__newHiddenTextPulseStarted) return;
  window.__newHiddenTextPulseStarted = true;

  var pulseIndex = 0;

  function pulse(icon) {
    if (!icon) return;

    var button = icon.closest(".btn-read-more");
    if (!button || button.classList.contains("active")) {
      setTimeout(function () {
        pulseIndex = (pulseIndex + 1) % buttons.length;
        pulse(buttons[pulseIndex].querySelector("img"));
      }, 500);
      return;
    }

    icon.style.transition = "transform 0.6s ease-in-out";
    icon.style.transform = "scale(1.2)";

    setTimeout(function () {
      icon.style.transform = "scale(1)";
      setTimeout(function () {
        pulseIndex = (pulseIndex + 1) % buttons.length;
        pulse(buttons[pulseIndex].querySelector("img"));
      }, 400);
    }, 600);
  }

  pulse(buttons[0].querySelector("img"));
})();
